<template>
    <div class="timeline__hoverable">
        <header class="timeline__header timeline__highlightable">
            <h3 class="timeline__title">
                {{ assignment.title }}
                <span v-if="hasFeedback" class="icon icon--inline icon--feedback" :class="{ 'icon--feedback-dark': isActive }" title="Heeft feedback gekregen"></span>
                <span v-if="shouldRetake" class="icon icon--inline icon--retake" :class="{ 'icon--retake-dark': isActive }" title="Opdracht opnieuw inleveren"></span>
                <span v-if="hasDiligence" class="diligence__icon diligence__icon--bg-replace diligence__icon--mini active" :class="'diligence__icon--' + diligence.tag" :title="diligence.tag"></span>
            </h3>

            <span class="timeline__meta">
                <span class="timeline__date">{{ date }}</span>
                <span class="timeline__progress" v-if="!progress.finished"> - stap {{ progress.step + 1 }}</span>
            </span>

        </header>

        <transition name="reveal">
            <p class="timeline__content timeline__content--submission" v-if="preview">
                <img v-if="type == 'Image'" :src="preview.data.thumb" class="timeline__thumbnail" />
                <span v-if="type == 'Text'" class="timeline__text">&ldquo;{{ previewText }}&rdquo;</span>
              <img v-if="hasBadge"
                class="timeline__badge"
                :class="{ 'timeline__badge--right' : type == 'Text' }"
                :src="`/build/img/badges/badge-${badge.type}-color-128x.png`"/>
            </p>
        </transition>

    </div>
</template>


<script>

import { date, excerpt } from 'js/helpers/transformers'

export default {
    props: {
        progress: {},
        isActive: {
            type: Boolean,
            default: false,
        }
    },

    computed: {

        assignment: function() {
            return this.$store.state.assignments.storage[ this.progress.assignment ]
        },

        preview: function() {
            if ( this.progress.primarySubmissions == null || this.progress.primarySubmissions.length < 1 ) {
                return null
            }
            return this.$store.state.submissions.storage[ this.progress.primarySubmissions[ this.progress.primarySubmissions.length - 1] ]
        },

        type: function() {
            if ( this.preview == null ) {
                return null
            }

            if ( this.preview.data instanceof Object && this.preview.data.medium != null && this.preview.data.thumb != null) {
                return 'Image'
            }

            return 'Text'

        },

        previewText: function() {

            if ( this.type !== 'Text' ) {
                return null
            }

            return excerpt(this.preview.data, 60)
        },

        hasFeedback: function() {
            if ( !this.progress.feedback || !this.progress.feedback.length ) {
                return false
            }

            const feedback = this.$store.state.feedback.storage[ this.progress.feedback[0] ]
            return feedback.content || feedback.remarks.length || feedback.compliments.length

        },

        hasDiligence: function() {
            return this.progress.diligence && this.progress.diligence.length
        },

        diligence: function() {
            if ( !this.hasDiligence ) {
                return null
            }

            return this.$store.state.diligence.storage[ this.progress.diligence[0] ]
        },

        hasBadge: function() {
            return this.progress.badge && this.progress.badge.length
        },

        badge: function () {
            if ( !this.hasBadge ) {
                return null
            }

            return this.$store.state.badges.storage[ this.progress.badge[0] ]
        },

        shouldRetake: function() {
            return this.progress.isRetaking
        },

        date: function() {
            return date( this.progress.started )
        },
    }
}
</script>


<style lang="scss">

    @import 'global';

    .diligence__icon.diligence__icon--mini {
        display: inline-block;
        float: none;
        transform: scale(0.6);
        vertical-align: middle;
        margin: -10px -2px;
    }

    .timeline__content--submission {
      position: relative;
      display: inline-block;
    }

    .timeline__badge {
      position: absolute;
      bottom: -10px;
      right: -30px;
      width: 64px;
      &--right {
        right: -10px;
        left: auto;
        bottom: -25px;
      }
    }

</style>



// WEBPACK FOOTER //
// Assignment.vue?65ee095d